//import { ReactDOM } from 'react';
import { useState, useEffect } from 'react';
import { Button, Card, Input, InputIcon, Textarea, PageHeader, Spinner } from '@salesforce/design-system-react';
import FooterComponent from '../../components/Footer';

var SDK = require('blocksdk');
var sdk = new SDK();

const TDG_IN_Upcoming_x3 = () => {

    const blockTitle = "TDG IN Upcoming x3";
    const [loading, setLoading] = useState('hidden');
    const [stateData, setStateData] = useState({
        inclusionId1: '',
        name1: '',
        date1: '',
        cta1: '',
        ctaLink1: '',
        image1: '',
        //
        inclusionId2: '',
        name2: '',
        date2: '',
        cta2: '',
        ctaLink2: '',
        image2: '',
        //
        inclusionId3: '',
        name3: '',
        date3: '',
        cta3: '',
        ctaLink3: '',
        image3: '',
    });

    //#region main functions
    const content = () => {
        return (`%%[
            SET @name1 = "${stateData.name1}"
            SET @date1 = "${stateData.date1}"
            SET @cta1 = "${stateData.cta1}"
            SET @ctaLink1 = "${stateData.ctaLink1}"
            SET @image1 = "${stateData.image1}"
            
            SET @name2 = "${stateData.name2}"
            SET @date2 = "${stateData.date2}"
            SET @cta2 = "${stateData.cta2}"
            SET @ctaLink2 = "${stateData.ctaLink2}"
            SET @image2 = "${stateData.image2}"
            
            SET @name3 = "${stateData.name3}"
            SET @date3 = "${stateData.date3}"
            SET @cta3 = "${stateData.cta3}"
            SET @ctaLink3 = "${stateData.ctaLink3}"
            SET @image3 = "${stateData.image3}"
        ]%%`)
    }
    const superContent = () => {
        return ('<div style="width: 100%; padding: 5px 0 5px 0; background-color: #ABED84; color: #333; font-size: 12px; font-weight: 500; letter-spacing: 2px; text-align: center;">'+blockTitle+'<br/><span style="font-size: 10px;">(this won\'t render)<span></div>');
    }
    useEffect(() => { // On Load
        sdk.setBlockEditorWidth(600); // Set Block Width
        sdk.getData((data) => {
            console.log("get data:", data);
            if (Object.keys(data).length === 0) return
            setStateData({ ...data });
        });
        sdk.setSuperContent(superContent());
    }, []);
    const onChangeValue = (e) => { // On Change Input
        console.log("on change value:", e.target.id, e.target.value);
        setStateData({ ...stateData, [e.target.id]: e.target.value });
    }
    const getInclusionData = async (id, num) => {
        setLoading('visible');
        const response = await fetch(`https://mc13x7pm08rd2hw7jlz8ghg8szzm.pub.sfmc-content.com/4qasgduhqgv?id=${id}`)
        const result = await response.json();
        // Regex
        const regExName = /(?<=\[Name\]:).*/;
        const regExDate = /(?<=\[Date\]:).*/;
        const regExCTA = /(?<=\[CTA\]:).*/;
        // cta link from field
        const regExImage480 = /(?<=\[Image480\]:).*/;
        // Match
        const matchName = result[0].Description__c.match(regExName);
        const matchDate = result[0].Description__c.match(regExDate);
        const matchCTA = result[0].Description__c.match(regExCTA);
        // cta link from field
        const matchImage480 = result[0].Description__c.match(regExImage480);
        // Trim
        const name = matchName ? matchName[0].trim() : '';
        const date = matchDate ? matchDate[0].trim() : '';
        const cta = matchCTA ? matchCTA[0].trim() : '';
        const ctaLink = result[0].CTA_Link__c;
        const image480 = matchImage480 ? matchImage480[0].trim() : '';
        // Set State
        console.log(ctaLink);
        setStateData({
            ...stateData,
            [`name${num}`]: name,
            [`date${num}`]: date,
            [`cta${num}`]: cta,
            [`ctaLink${num}`]: ctaLink,
            [`image${num}`]: image480,
        });
        setLoading('hidden');
    }
    const setData = () => {
        setLoading('visible');
        console.log("set data:", stateData);
        sdk.setData({ ...stateData });
        sdk.setContent(content());
        sdk.setSuperContent(superContent());
        setLoading('hidden');
    }
    //#endregion

    return (
        <div>

            <div className="slds-page-header__title" style={{ margin: 10 }}>
                TDG IN Upcoming x3
            </div>

            {/* Upcoming 1 */}
            <Card heading="Upcoming 1">
                <Input
                    label="Inclusion ID"
                    id="inclusionId1"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.inclusionId1}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Button
                    label="Get Inclusion Data"
                    iconCategory="utility"
                    iconName="salesforce1"
                    iconPosition="left"
                    // disabled={stateData?.Id?.length != 18 || stateData?.Email_ID__c?.length === 0}
                    style={{ margin: 3 }}
                    onClick={() => getInclusionData(stateData.inclusionId1, "1")}
                />
                <Input
                    label="Name"
                    id="name1"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.name1}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="Date"
                    id="date1"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.date1}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="CTA"
                    id="cta1"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.cta1}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="URL"
                    id="ctaLink1"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.ctaLink1}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="Image"
                    id="image1"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.image1}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                    // iconRight={
                    //     <InputIcon
                    //         assistiveText={{
                    //             icon: 'Clear',
                    //         }}
                    //         name="upload"
                    //         category="utility"
                    //         size="x-small"
                    //         colorVariant="default"
                    //         onClick={(e) => {
                    //             console.log('Icon Clicked');
                    //         }}
                    //     />
                    // }
                />
                <Button
                    label="Save"
                    iconCategory="utility"
                    iconName="save"
                    iconPosition="left"
                    // disabled={stateData?.Id?.length != 18 || stateData?.Email_ID__c?.length === 0}
                    style={{ margin: 3 }}
                    onClick={setData}
                />
            </Card>

            {/* Upcoming 2 */}
            <Card heading="Upcoming 2">
                <Input
                    label="Inclusion ID"
                    id="inclusionId2"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.inclusionId2}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Button
                    label="Get Inclusion Data"
                    iconCategory="utility"
                    iconName="salesforce1"
                    iconPosition="left"
                    // disabled={stateData?.Id?.length != 18 || stateData?.Email_ID__c?.length === 0}
                    style={{ margin: 3 }}
                    onClick={() => getInclusionData(stateData.inclusionId2, "2")}
                />
                <Input
                    label="Name"
                    id="name2"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.name2}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />

                <Input
                    label="Date"
                    id="date2"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.date2}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="CTA"
                    id="cta2"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.cta2}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="URL"
                    id="ctaLink2"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.ctaLink2}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="Image"
                    id="image2"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.image2}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Button
                    label="Save"
                    iconCategory="utility"
                    iconName="save"
                    iconPosition="left"
                    // disabled={stateData?.Id?.length != 18 || stateData?.Email_ID__c?.length === 0}
                    style={{ margin: 3 }}
                    onClick={setData}
                />
            </Card>
            {/* Upcoming 3 */}
            <Card heading="Upcoming 3">
            <Input
                    label="Inclusion ID"
                    id="inclusionId3"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.inclusionId3}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Button
                    label="Get Inclusion Data"
                    iconCategory="utility"
                    iconName="salesforce1"
                    iconPosition="left"
                    // disabled={stateData?.Id?.length != 18 || stateData?.Email_ID__c?.length === 0}
                    style={{ margin: 3 }}
                    onClick={() => getInclusionData(stateData.inclusionId3, "3")}
                />
                <Input
                    label="Name"
                    id="name3"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.name3}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="Date"
                    id="date3"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.date3}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="CTA"
                    id="cta3"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.cta3}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Input
                    label="URL"
                    id="ctaLink3"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.ctaLink3}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                 <Input
                    label="Image"
                    id="image3"
                    placeholder=""
                    onChange={onChangeValue}
                    value={stateData.image3}
                    styleInput={{ textAlign: 'left' }}
                    styleContainer={{}}
                />
                <Button
                    label="Save"
                    iconCategory="utility"
                    iconName="save"
                    iconPosition="left"
                    // disabled={stateData?.Id?.length != 18 || stateData?.Email_ID__c?.length === 0}
                    style={{ margin: 3 }}
                    onClick={setData}
                />
            </Card>

            {/********** Loading Spinner **********/}
            <Spinner
                containerStyle={{ visibility: loading }}
                size="small"
                variant="brand"
                assistiveText={{ label: 'Main Frame Loading...' }}
            />
            {/********** Footer **********/}
            <FooterComponent />
        </div>
    )

}

export default TDG_IN_Upcoming_x3